(function() { window.GUID_7b6a96a9_efe4_4f53_a7d5_d7342a215c34 = { getGuid: function() { return "7b6a96a9-efe4-4f53-a7d5-d7342a215c34"; } }; })();
/** Server access of the score sheet finder. */
class ScoreSheetFinderApi {
    constructor() { }
    /**
     * Posts the filter request built by the store and hands the results back.
     * The callback is not invoked when the server answers with something else than a
     * list of results, so that the finder keeps the results it already has.
     */
    static filter(request, callback) {
        try {
            CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetFinder/Filter/", request, function (response) {
                try {
                    if (!Array.isArray(response)) {
                        throw new Error("Response is not an array");
                    }
                    callback(response);
                }
                catch (error) {
                    console.error("Error while filtering score sheets", error);
                }
            });
        }
        catch (error) {
            console.error("Error while filtering score sheets", error);
        }
    }
    /**
     * Fetches the content of both drawers. Their markup is rendered by partial views
     * and injected into the drawers once loaded.
     */
    static getDrawersContent(filters, callback) {
        try {
            CompuSport.Ajax.Get("/ScoreSheetFinder/AdvancedFiltersDrawer", {}, function (advancedFiltersDrawerContent) {
                CompuSport.Ajax.Get("/ScoreSheetFinder/RoundRotationsDrawer", filters, function (rotationsDrawerContent) {
                    callback({
                        advancedFiltersDrawerContent: advancedFiltersDrawerContent,
                        rotationsDrawerContent: rotationsDrawerContent,
                    });
                });
            });
        }
        catch (error) {
            console.error("Error while fetching drawer content", error);
        }
    }
}

//# sourceMappingURL=ScoreSheetFinderApi.js.map
